import { Box, Grid2 as Grid, Typography } from '@mui/material';

import MobileContentBG from '../../assets/mobileContentBG.png';
import React from 'react';
import TalentImg from '../../assets/fight.png';
import content_Bg from '../../assets/ContentBG.webp';

interface TalentProps {
  isMobile?: Boolean | null;
}

const Talent: React.FC<TalentProps> = ({ isMobile }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden'
      }}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          size={{ xs: 12, md: 8 }}
          sx={{ display: { xs: 'none', md: 'flex' } }}>
          <Box p={6}>
            <Typography
              style={{
                fontFamily: 'Bevan',

                fontSize: '48px',
                lineHeight: '1'
              }}>
              <span style={{ color: 'white' }}>{`“ `}</span>
              <span
                style={{
                  background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                {` Champsverse Vs`}
              </span>
            </Typography>
            {/* <Typography
              style={{
                fontFamily: 'Bevan',
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '48px',
                textAlign: 'center',
                marginLeft: '-10px'
              }}>
              {`Vs`}
            </Typography> */}
            <Typography
              style={{
                fontFamily: 'Bevan',
                fontSize: '48px'
              }}>
              <span
                style={{
                  background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                {`Digital Toxicity `}
              </span>

              <span style={{ color: 'white' }}>{`”`}</span>
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Baloo2',
                color: '#fff',
                whiteSpace: 'pre-line',
                fontSize: '19px'
              }}>
              Champsverse fights digital toxicity by turning passive screen time into
              {'\n'}
              purposeful creativity. Children complete offline activities and are rewarded {'\n'}
              through the app, creating a healthier dopamine cycle. This hybrid {'\n'}
              approach encourages focus, balance, and meaningful tech use—helping {'\n'}
              kids grow, not just scroll.
            </Typography>
          </Box>
        </Grid>

        <Grid
          size={{ xs: 12, md: 8 }}
          sx={{
            display: { xs: 'block', md: 'none' },
            margin: '30px 0'
          }}>
          <Typography fontSize={20} fontWeight={800} fontFamily={'Bevan'} align="center">
            <span style={{ color: 'white' }}>{`“ `}</span>
            <span
              style={{
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              {`  Champsverse vs `}
            </span>
          </Typography>

          {/* <Typography
            fontSize={20}
            fontWeight={800}
            fontFamily={'Bevan'}
            align="center"
            sx={{
              background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
            Vs
          </Typography> */}
          <Typography fontSize={20} fontWeight={800} fontFamily={'Bevan'} align="center">
            <span
              style={{
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              {`Digital Toxicity  `}
            </span>

            <span style={{ color: 'white' }}>{`”`}</span>
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Baloo2',
              fontWeight: 500,
              fontSize: '15px',
              pt: '10px',
              color: 'white',
              textAlign: 'center',
              margin: '0 40px'
            }}>
            Champsverse fights digital toxicity by turning passive screen time into
            {'\n'}
            purposeful creativity. Children complete offline activities and are rewarded {'\n'}
            through the app, creating a healthier dopamine cycle. This hybrid {'\n'}
            approach encourages focus, balance, and meaningful tech use—helping {'\n'}
            kids grow, not just scroll.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <img
              src={TalentImg}
              alt="learning"
              style={{
                width: isMobile ? '400px' : 570,
                height: isMobile ? '266px' : 'auto'
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default Talent;
